import { render, staticRenderFns } from "./v-spinner.vue?vue&type=template&id=3baad8ad&scoped=true"
import script from "./v-spinner.vue?vue&type=script&lang=ts"
export * from "./v-spinner.vue?vue&type=script&lang=ts"
import style0 from "./v-spinner.vue?vue&type=style&index=0&id=3baad8ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baad8ad",
  null
  
)

export default component.exports